import React from "react";

export default function Instruction() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center space-x-4 mb-8 border-b pb-4">
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
          <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-slate-900">Before You Begin</h2>
      </div>

      <div className="prose prose-lg text-gray-700 mb-10 max-w-none">
        <p>
          This service, as one of the functions of the Nigeria Police Force to
          protect the property of citizens in Nigeria, is created for members of
          the public to report their stolen vehicle between <strong>1st January 2013 to date</strong>.
        </p>
        <p>
          It is a <strong>free service</strong> and a precursor to the migration of the current
          manual method of registering vehicles by the CMR with the aim of
          checkmating and preventing the registration of stolen vehicles in the
          digitalized CMR database.
        </p>
      </div>

      <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl mb-10">
        <h3 className="text-lg font-bold text-amber-900 mb-2">Important Deadline</h3>
        <p className="text-amber-800">
          This service is available up till <strong>30th November 2022</strong> as the modernized
          CMR operations including its e-enforcement will commence on 1st December
          2022. Please seize this window of opportunity to support recovery efforts.
        </p>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-xl p-8 mb-8">
        <h3 className="text-xl font-bold text-slate-900 mb-6">Required Documents</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <li className="flex items-center text-slate-700 bg-white p-4 rounded-lg shadow-sm border border-slate-100">
            <svg className="w-5 h-5 text-green-500 mr-3 shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
            Police Extract of Report
          </li>
          <li className="flex items-center text-slate-700 bg-white p-4 rounded-lg shadow-sm border border-slate-100">
            <svg className="w-5 h-5 text-green-500 mr-3 shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
            Valid ID (BVN, Driver's License, TIN)
          </li>
          <li className="flex items-center text-slate-700 bg-white p-4 rounded-lg shadow-sm border border-slate-100">
            <svg className="w-5 h-5 text-green-500 mr-3 shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
            Proof of Ownership (If available)
          </li>
          <li className="flex items-center text-slate-700 bg-white p-4 rounded-lg shadow-sm border border-slate-100">
            <svg className="w-5 h-5 text-green-500 mr-3 shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
            Affidavit attested to over theft
          </li>
        </ul>
        <p className="mt-6 text-sm text-slate-500 italic">
          * If you have not collected a police extract, please visit the station where you made the report to retrieve it. Inaccurate information will invalidate your submission.
        </p>
      </div>
    </div>
  );
}